<div class="routing-position-editor" [formGroup]="form">

  <div style="grid-column: 1; grid-row: 1;">
    <sc-flex centered>
      <sc-string-field style="align-self: center" formControlName="stationName" labelDictionaryKey="tmc-yard.entity.station.name"></sc-string-field>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon [disabled]="form.disabled" iconClass="fa-sitemap" (click)="assignStation()">
      </sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
    </sc-flex>
  </div>

  <sc-select-field formControlName="actionType" [data]="availableActionTypes" style="grid-column: 2; grid-row: 1;"
    labelDictionaryKey="tmc-yard.common.transport-routing.routingPosition.actionType"></sc-select-field>

  <div style="grid-column: 3; grid-row: 1;">
    <sc-content-spacer></sc-content-spacer>
    <!-- <sc-button iconClass="fa-tasks" primary [disabled]="form.disabled" (click)="assignTasks()"></sc-button> -->
    <sc-action-icon [disabled]="form.disabled" iconClass="fa-tasks" (click)="assignTasks()"></sc-action-icon>
    <sc-content-spacer></sc-content-spacer>
  </div>

  <sc-string-field formControlName="cargo" style="grid-row: 2;"
    labelDictionaryKey="tmc-yard.common.transport-routing.routingPosition.cargo"></sc-string-field>

  <sc-checkbox-field formControlName="waitingForRetrieve" style="grid-column: 2; grid-row: 2; align-self: center;"
    labelDictionaryKey="tmc-yard.common.transport-routing.routingPosition.waitingForRetrieve"></sc-checkbox-field>

  <sc-string-field formControlName="predictedDuration" style="grid-column: 3; grid-row: 2;"
    labelDictionaryKey="tmc-yard.common.transport-routing.routingPosition.predicted-duration"></sc-string-field>

  <sc-select-field formControlName="stationAssignmentStrategy" style="grid-column: 1; grid-row: 3;"
    [data]="availableStationAssignmentStrategyOptions"
    labelDictionaryKey="tmc-yard.common.entity.station-assignment-strategy"></sc-select-field>

  <sc-string-field formControlName="hint" style="grid-column: 2 / span 3; grid-row: 3;"
    labelDictionaryKey="tmc-yard.common.transport-routing.routingPosition.hint"></sc-string-field>


</div>
